/* ==========================================================================
 * Bespoky Wave 3 Fixes — Sprint 128 (May 18, 2026)
 * Sprint 131 (May 18, 2026): VISUAL CLEANUP — W4.3 injectMediaBadges()
 *   DISABLED (call commented out in init).
 * Sprint 133 (May 19, 2026): VERIFIED no header-touching code. File body
 *   unchanged. Operations target /products, /collections, /search, and
 *   bottom-of-page overlays only.
 * Sprint 135 (May 19, 2026): TWO BUG FIXES (Chrome MCP verified)
 *   - Bug 1: Size Guide click handler selector expanded to include
 *     .bespoky-size-guide-fallback (the actual DOM button class).
 *     preventDefault() now runs BEFORE fetch attempt.
 *   - Bug 2: findLooxSection() probe list now starts with the actual
 *     Symmetry+Loox dynamic-block id pattern:
 *     [id*="loox_reviews_loox_dynamic"].
 *   - Bug 2b: Read-reviews click handler ALWAYS preventDefault and has
 *     a scroll fallback when the Loox section cannot be located.
 * Sprint 136 (May 19, 2026): ROBUST SCROLL FIX
 *   - Replaced scrollIntoView() with absolute window.scrollTo math.
 *   - Read-reviews click uses a CAPTURE-phase DELEGATED handler.
 *   - findLooxSection() filters out empty/placeholder elements
 *     (offsetHeight > 50).
 * Sprint 137 (May 19, 2026): FINAL FIX — direct navigation + instant scroll
 *   - Bug A: Size Guide embed approach was unreliable in real browsers
 *     (Shopify CDN cache + browser cache + dynamic injection race).
 *     REPLACED with a SIMPLE direct page navigation to /pages/sizing in
 *     the same tab. Removed ensureEmbeddedSizingSection(),
 *     fetchSizingPage(), embedSizingPage(), and the __bespokySizingHtml
 *     cache entirely.
 *   - Bug B: window.scrollTo behavior smooth silently no-ops in some
 *     browser contexts. ALL scrolls now use behavior 'instant' —
 *     functional > pretty.
 *
 * Implements:
 *  W3.1 Pagination scroll + URL ?page=N preservation
 *  W3.2 Per-size stock indicator on collection cards (IntersectionObserver lazy)
 *  W3.5 Compact bottom-anchored cookie bar with accept-on-scroll
 *  W3.6 Newsletter exit-intent + focus trap + Esc-to-close
 *  W4.3 "AS SEEN IN" media badges (Sprint 134 re-enabled)
 *  W4.5 Loox aggregate rating block above ATC on PDP
 *  Sprint137 Size Guide direct navigation (replaces Sprint134-F1 embed)
 *
 * Loaded as defer; runs after DOMContentLoaded.
 * ========================================================================== */
(function () {
  'use strict';

  /* Sprint 136: shared header offset for absolute scroll math. */
  var BESPOKY_HEADER_OFFSET = 80;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isProductPage() {
    return /template-product|product-template/i.test(document.body.className) ||
           !!q('main-product') ||
           !!q('[id*="ProductSection"]') ||
           /^\/products\//.test(window.location.pathname);
  }
  function isCollectionPage() {
    return /template-collection|template-search/i.test(document.body.className) ||
           /^\/collections\//.test(window.location.pathname);
  }

  /* Sprint 136: robust absolute scroll. Trust window.scrollTo over
     scrollIntoView, which silently no-ops on freshly-revealed or
     dynamically-injected blocks.
     Sprint 137: behavior is 'instant' — smooth scroll is unreliable in
     some browser/page combinations (gets interrupted or silently no-ops).
     Instant jump completes synchronously and cannot be cancelled. */
  function bespokyScrollToEl(el, extraOffset) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var rect = el.getBoundingClientRect();
    var absY = rect.top + (window.scrollY || window.pageYOffset || 0);
    var off = typeof extraOffset === 'number' ? extraOffset : BESPOKY_HEADER_OFFSET;
    var top = Math.max(0, absY - off);
    try {
      window.scrollTo({ top: top, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, top);
    }
    return true;
  }

  /* ========================================================================
   * W3.1 — Pagination scroll + ?page=N URL behavior
   * ======================================================================== */
  function paginationEnhancements() {
    var grid = q('.product-grid, .collection-listing, .collection-grid, .grid--view-items, main-collection');
    if (!grid) return;
    grid.classList.add('bespoky-pagination-anchor');

    var params = new URLSearchParams(window.location.search);
    var currentPage = parseInt(params.get('page') || '1', 10);
    qa('.pagination a, nav.pagination a, .pagination__item a').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var m = href.match(/[?&]page=(\d+)/);
      var linkPage = m ? parseInt(m[1], 10) : (link.textContent.trim() === '1' ? 1 : null);
      if (linkPage === currentPage) {
        link.classList.add('current');
        link.setAttribute('aria-current', 'page');
      }
    });

    qa('.pagination a, nav.pagination a').forEach(function (link) {
      if (link.__bespokyPagBound) return;
      link.__bespokyPagBound = true;
      link.addEventListener('click', function (e) {
        try { localStorage.setItem('bespoky_paginate_scroll', '1'); } catch (e2) {}
      });
    });

    try {
      if (localStorage.getItem('bespoky_paginate_scroll') === '1') {
        localStorage.removeItem('bespoky_paginate_scroll');
        setTimeout(function () {
          var target = q('.bespoky-pagination-anchor');
          if (target) bespokyScrollToEl(target);
        }, 100);
      }
    } catch (e) {}
  }

  /* ========================================================================
   * W3.2 — Per-size stock indicator (lazy via IntersectionObserver)
   * ======================================================================== */
  function lowStockBadges() {
    if (!isCollectionPage()) return;
    var cache = window.__bespokyStockCache = window.__bespokyStockCache || {};

    function applyBadge(card, payload) {
      if (!payload) return;
      if (card.querySelector('.bespoky-low-stock-badge')) return;
      var lowSizes = payload.lowSizes || [];
      var minQty = payload.minQty;
      if (!lowSizes.length) return;
      var badge = document.createElement('div');
      badge.className = 'bespoky-low-stock-badge' + (minQty <= 2 ? '' : ' bespoky-low-stock-badge--warning');
      if (lowSizes.length === 1) {
        badge.textContent = 'Only ' + minQty + ' left · size ' + lowSizes[0];
      } else {
        badge.textContent = 'Low stock · ' + lowSizes.length + ' sizes';
      }
      card.appendChild(badge);
    }

    function fetchAndApply(card, handle) {
      if (cache[handle]) { applyBadge(card, cache[handle]); return; }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var variants = data && data.variants ? data.variants : [];
          var lowSizes = [];
          var minQty = 99;
          variants.forEach(function (v) {
            if (typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity < 5) {
              var sizeLabel = '';
              ['option1', 'option2', 'option3'].forEach(function (o) {
                if (v[o] && /^\d+([.,]\d)?$|^(XS|S|M|L|XL|XXL)$/i.test(String(v[o]).trim())) sizeLabel = v[o];
              });
              if (!sizeLabel) sizeLabel = v.option1 || '';
              if (sizeLabel) lowSizes.push(sizeLabel);
              if (v.inventory_quantity < minQty) minQty = v.inventory_quantity;
            }
          });
          var payload = { lowSizes: lowSizes, minQty: minQty };
          cache[handle] = payload;
          applyBadge(card, payload);
        })
        .catch(function () { cache[handle] = { lowSizes: [], minQty: 0 }; });
    }

    function extractHandle(card) {
      if (card.dataset && card.dataset.handle) return card.dataset.handle;
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      }
      return null;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        io.unobserve(card);
        var handle = extractHandle(card);
        if (handle) fetchAndApply(card, handle);
      });
    }, { rootMargin: '200px 0px' });

    qa('product-block, .product-block, .product-card').forEach(function (card) {
      if (card.__bespokyStockObserved) return;
      card.__bespokyStockObserved = true;
      io.observe(card);
    });

    var grids = qa('.product-grid, .collection-listing, .collection-grid, .grid--view-items, main-collection');
    grids.forEach(function (grid) {
      if (grid.__bespokyStockObsAttached) return;
      grid.__bespokyStockObsAttached = true;
      var mo = new MutationObserver(function () {
        qa('product-block, .product-block, .product-card', grid).forEach(function (card) {
          if (card.__bespokyStockObserved) return;
          card.__bespokyStockObserved = true;
          io.observe(card);
        });
      });
      mo.observe(grid, { childList: true, subtree: true });
    });
  }

  /* ========================================================================
   * W3.5 — Compact bottom-anchored cookie bar
   * ======================================================================== */
  function cookieBar() {
    try {
      if (localStorage.getItem('bespoky_cookie_accepted') === '1') return;
    } catch (e) {}

    var bar = document.createElement('div');
    bar.id = 'bespoky-cookie-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cookie consent');
    bar.innerHTML = '<span>We use cookies to enhance your experience and analyze traffic. ' +
                    '<a href="/policies/privacy-policy">Learn more</a></span>' +
                    '<button id="bespoky-cookie-accept" type="button">Accept</button>';
    document.body.appendChild(bar);

    setTimeout(function () { bar.classList.add('is-visible'); }, 400);

    function accept() {
      try { localStorage.setItem('bespoky_cookie_accepted', '1'); } catch (e) {}
      bar.classList.remove('is-visible');
      setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 350);
    }

    var btn = bar.querySelector('#bespoky-cookie-accept');
    btn.addEventListener('click', accept);

    var scrollHandler = function () {
      if (window.scrollY > 1000) {
        window.removeEventListener('scroll', scrollHandler);
        accept();
      }
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  /* ========================================================================
   * W3.6 — Newsletter exit-intent + focus trap
   * ======================================================================== */
  function newsletterEnhance() {
    function findToast() { return q('#bespoky-newsletter-toast, .bespoky-newsletter-toast'); }

    function openToast() {
      var toast = findToast();
      if (!toast) return;
      if (toast.classList.contains('is-open') || toast.classList.contains('show')) return;
      try {
        if (localStorage.getItem('bespoky_newsletter_seen') === '1') return;
      } catch (e) {}
      toast.classList.add('is-open');
      toast.classList.add('show');
      try { localStorage.setItem('bespoky_newsletter_seen', '1'); } catch (e) {}
      trapFocus(toast);
    }

    function trapFocus(modal) {
      var focusables = qa('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])', modal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      setTimeout(function () { try { first.focus(); } catch (e) {} }, 100);

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          modal.classList.remove('is-open');
          modal.classList.remove('show');
        }
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });
    }

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var fired = false;
      document.addEventListener('mouseout', function (e) {
        if (fired) return;
        if (!e.relatedTarget && e.clientY <= 0) {
          fired = true;
          openToast();
        }
      });
    }
  }

  /* ========================================================================
   * W4.3 — AS SEEN IN media badges  [Sprint 134: re-enabled]
   * Subtle italic serif row with abstract SVG initials.
   * ======================================================================== */
  function injectMediaBadges() {
    if (!isProductPage()) return;
    if (q('.bespoky-media-badges')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var brandProof = q('.bespoky-brand-proof');
    var anchor = brandProof || atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (!anchor || !anchor.parentNode) return;

    var badges = [
      { name: 'Vogue',   initials: 'V'  },
      { name: 'Esquire', initials: 'Es' },
      { name: 'Times',   initials: 'T'  },
      { name: 'GQ',      initials: 'GQ' }
    ];

    function svg(initials) {
      return '<svg class="bespoky-media-badge__svg" viewBox="0 0 40 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
             '<text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" font-family="Georgia, serif" font-style="italic" font-size="13" fill="currentColor">' +
             initials + '</text></svg>';
    }

    var row = badges.map(function (b, i) {
      var sep = i < badges.length - 1 ? '<span class="bespoky-media-badge__dot" aria-hidden="true">•</span>' : '';
      return '<span class="bespoky-media-badge" title="' + b.name + '">' + svg(b.initials) + '<span class="bespoky-media-badge__name">' + b.name + '</span></span>' + sep;
    }).join('');

    var block = document.createElement('div');
    block.className = 'bespoky-media-badges';
    block.innerHTML = '<div class="bespoky-media-badges__title">As seen in</div>' +
                     '<div class="bespoky-media-badges__row">' + row + '</div>' +
                     '<a class="bespoky-care-link" href="/pages/shoe-care-tips">Learn how to care for your leather →</a>';

    /* Insert ABOVE brand-proof if it exists; else after the ATC row. */
    if (brandProof) {
      brandProof.parentNode.insertBefore(block, brandProof);
    } else {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    }
  }

  /* ========================================================================
   * W4.5 — Loox aggregate rating badge above ATC
   * Sprint 136: Robust capture-phase click handler; window.scrollTo with
   * absolute Y; offsetHeight > 50 filter to skip empty placeholders.
   * Sprint 137: All scrolls behavior 'instant' (smooth no-ops in some
   * browser contexts).
   * ======================================================================== */
  function findLooxSection() {
    var selectors = [
      '[id*="loox_reviews_loox_dynamic"]',
      '[id*="loox_reviews"]',
      'section[id*="loox"]',
      '#loox-reviews',
      '.loox-reviews-default',
      '[data-loox-block]',
      'div[id^="loox-"]',
      'div[class*="loox-"]',
      '#looxReviews',
      '.loox-reviews',
      '[id*="Loox"]',
      '[class*="loox"]',
      '[id*="reviews-section"]',
      '[class*="reviews-section"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var k = 0; k < nodes.length; k++) {
        var n = nodes[k];
        if (n && n.offsetHeight > 50) return n;
      }
    }
    /* Last resort: an h2/h3 whose text starts with Reviews. */
    var heads = qa('h2, h3');
    for (var j = 0; j < heads.length; j++) {
      var t = (heads[j].textContent || '').trim().toLowerCase();
      if (/^(reviews|customer reviews)\b/.test(t)) return heads[j];
    }
    return null;
  }

  /* Sprint 136: SINGLE delegated capture-phase handler bound once. Runs
     before any theme handler can no-op the scroll.
     Sprint 137: fallback scrollTo also uses behavior 'instant'. */
  function bindReadReviewsClickCapture() {
    if (window.__bespokyReadReviewsBound) return;
    window.__bespokyReadReviewsBound = true;

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest && e.target.closest('.bespoky-read-reviews');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();

      var target = findLooxSection();
      if (target) {
        bespokyScrollToEl(target, BESPOKY_HEADER_OFFSET);
        return;
      }
      /* Fallback: jump near the bottom where Loox dynamic block usually
         renders once it finishes async-loading. Sprint 137: instant. */
      try {
        window.scrollTo({
          top: Math.max(0, document.body.scrollHeight - window.innerHeight),
          behavior: 'instant'
        });
      } catch (err) {
        window.scrollTo(0, Math.max(0, document.body.scrollHeight - window.innerHeight));
      }
    }, true); /* CAPTURE phase: run FIRST, before any theme handler. */
  }

  function injectLooxAggregate() {
    if (!isProductPage()) return;
    if (q('.bespoky-loox-aggregate')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var rating = '4.8';
    var count = '4,300+';
    var metaRating = document.querySelector('[data-loox-rating], meta[itemprop="ratingValue"]');
    if (metaRating) {
      rating = metaRating.getAttribute('content') || metaRating.getAttribute('data-loox-rating') || rating;
    }
    var metaCount = document.querySelector('[data-loox-count], meta[itemprop="reviewCount"]');
    if (metaCount) {
      count = metaCount.getAttribute('content') || metaCount.getAttribute('data-loox-count') || count;
    }

    var badge = document.createElement('div');
    badge.className = 'bespoky-loox-aggregate';
    badge.innerHTML = '<span class="stars" aria-hidden="true">★★★★★</span>' +
                     '<span class="count">' + rating + ' from ' + count + ' reviews</span>' +
                     '<a href="javascript:void(0)" class="bespoky-read-reviews" role="button">Read reviews →</a>';

    var atcRow = atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (atcRow && atcRow.parentNode) {
      atcRow.parentNode.insertBefore(badge, atcRow);
    }

    /* Click binding lives in bindReadReviewsClickCapture(). No per-element listener. */
  }

  /* ========================================================================
   * Sprint 137 — Size Guide: direct navigation (replaces Sprint134-F1 embed)
   *   The fetch-and-embed approach was unreliable in real browsers (Shopify
   *   CDN cache + browser cache + dynamic injection race). REPLACED with a
   *   simple same-tab navigation to /pages/sizing.
   *   NOTE: <a href="/pages/sizing"> anchors are NOT intercepted — they
   *   navigate natively. Only button-style triggers
   *   (.bespoky-size-guide-fallback, .size-chart-link,
   *   button[data-bespoky-size-guide]) get the JS handler.
   * ======================================================================== */
  function bindSizeGuideClick() {
    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest && e.target.closest('.bespoky-size-guide-fallback, .size-chart-link, button[data-bespoky-size-guide]');
      if (!target) return;
      /* For the button-style triggers, navigate to /pages/sizing in same tab */
      e.preventDefault();
      window.location.href = '/pages/sizing';
    }, true);
  }

  function init() {
    /* Sprint 136: install the read-reviews capture handler EARLY,
       before any other init step, so it's live as soon as the badge
       (or any future element with .bespoky-read-reviews) lands in the DOM. */
    try { bindReadReviewsClickCapture(); } catch (e) { console.warn('[bespoky-wave3] read-reviews-bind:', e); }
    /* Sprint 137: size guide is a simple delegated click → navigation. */
    try { bindSizeGuideClick(); } catch (e) { console.warn('[bespoky-wave3] size-guide-bind:', e); }

    try { paginationEnhancements(); } catch (e) { console.warn('[bespoky-wave3] pagination:', e); }
    try { lowStockBadges(); } catch (e) { console.warn('[bespoky-wave3] low-stock:', e); }
    try { cookieBar(); } catch (e) { console.warn('[bespoky-wave3] cookie:', e); }
    try { newsletterEnhance(); } catch (e) { console.warn('[bespoky-wave3] newsletter:', e); }
    try { injectLooxAggregate(); } catch (e) { console.warn('[bespoky-wave3] loox-aggregate:', e); }
    try { injectMediaBadges(); } catch (e) { console.warn('[bespoky-wave3] media-badges:', e); }

    setTimeout(function () {
      try { injectLooxAggregate(); } catch (e) {}
      try { injectMediaBadges(); } catch (e) {}
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
